import script from "./EcommerceOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceOrder.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceOrder.vue?vue&type=style&index=0&id=8b2f2176&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b2f2176"]])

export default __exports__